import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const PaymentFailed = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [cancelling, setCancelling] = useState(false);

  useEffect(() => {
    // Cancel the pending order
    const cancelOrder = async () => {
      try {
        setCancelling(true);
        const token = localStorage.getItem('token');
        
        // Get the most recent pending order for this user
        const ordersRes = await axios.get(
          `${process.env.REACT_APP_API}/api/orders/my-orders`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        const pendingOrders = ordersRes.data.filter(
          order => (order.status === 'Pending' || order.status === 'Awaiting Payment') && 
                   order.paymentStatus === 'pending' && 
                   (order.paymentMethod === 'online' || order.paymentMethod === 'gcash-paymongo')
        );
        
        // Cancel the most recent pending PayMongo order
        if (pendingOrders.length > 0) {
          const mostRecent = pendingOrders.sort((a, b) => 
            new Date(b.createdAt) - new Date(a.createdAt)
          )[0];
          
          await axios.patch(
            `${process.env.REACT_APP_API}/api/orders/${mostRecent._id}/status`,
            { 
              status: 'Cancelled',
              message: 'Payment failed or expired'
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          
          console.log(`Cancelled order ${mostRecent._id} due to payment failure`);
        }
      } catch (error) {
        console.error('Error cancelling order:', error);
      } finally {
        setCancelling(false);
      }
    };

    cancelOrder();

    const timer = setTimeout(() => {
      navigate('/orders');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, searchParams]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%)',
      color: 'white',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '3rem 2rem',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>❌</div>
        <h1 style={{ color: '#d32f2f', marginBottom: '1rem', fontSize: '2rem' }}>
          Payment Failed
        </h1>
        <p style={{ color: '#666', fontSize: '1.1rem', marginBottom: '2rem' }}>
          {cancelling 
            ? 'Cancelling your order...' 
            : 'We couldn\'t process your payment. Your order has been cancelled.'}
        </p>
        <p style={{ color: '#888', fontSize: '0.9rem' }}>
          Redirecting to your orders in 5 seconds...
        </p>
        <button
          onClick={() => navigate('/orders')}
          style={{
            marginTop: '1.5rem',
            padding: '12px 32px',
            background: '#d32f2f',
            color: 'white',
            border: 'none',
            borderRadius: '24px',
            fontSize: '1rem',
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(211,47,47,0.3)'
          }}
        >
          View Orders
        </button>
      </div>
    </div>
  );
};

export default PaymentFailed;
